import React, { useRef, useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { RBButton } from "../../components/RBButton";
import { makeStyles, Grid, Typography, Box, Link, CircularProgress } from "@material-ui/core";
import { Spacing, Colors } from "../../theme/Theme";
import { RBCardView } from "../../components/RBCardView";
import { RoutePathConstant } from "../../util/Common";
import { AuthService } from "../../api/AuthService";

const useStyles = makeStyles((theme) => ({
  inputContainer: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: Spacing.larger,
    marginLeft: 3 * Spacing.larger,
    marginRight: 3 * Spacing.larger,
  },
cardWrapper: {
  width: "700px !important",
  maxWidth: "700px !important",
  minWidth: "700px !important",
  boxSizing: "border-box",

  [theme.breakpoints.down("sm")]: {
    width: "100% !important",
    maxWidth: "100% !important",
    minWidth: "auto !important",
  },
},


 logo: {
  display: "block",
  marginLeft: "auto",
  marginRight: "auto",
  paddingLeft: 3 * Spacing.large,
  paddingRight: 3 * Spacing.large,
  paddingTop: Spacing.large,
  paddingBottom: Spacing.large,
  maxWidth: "100%",
  height: "auto",
},

  buttonContainer: {
    display: "flex",
   // flexDirection: "column",
    justifyContent: "space-between",
    marginTop: 2 * Spacing.larger,
    paddingLeft: 3 * Spacing.large,
    paddingRight: 3 * Spacing.large,
  },
  welcomeText: {
    fontSize: 18,
    fontWeight: "bold",
    textAlign: "center",
    marginTop: 10,
    paddingBottom: 10,
  },
  subText: {
    textAlign: "center",
  },
  button: {
    width: "75%",
    paddingLeft: Spacing.large,
    paddingRight: Spacing.large,
    paddingTop: Spacing.medium,
    paddingBottom: Spacing.medium,
    marginBottom: 20,
    minHeight:50,
    margin:"auto"
  },
  loginButton: {
    width: "75%",
    paddingLeft: Spacing.large,
    paddingRight: Spacing.large,
    paddingTop: Spacing.medium,
    paddingBottom: Spacing.medium,
    minHeight:50,
    margin:"auto",
    backgroundColor: 'white', // Set background color to white
    color: 'black', // Set text color to black
    borderColor: 'black', // Set border color to black
    border: '1px solid', // Ensure the border is visible
  },
  registerContainer: {
    textAlign: "center",
    paddingBottom: Spacing.larger,
    // marginTop: Spacing.small,
  },
  registerLink: {
    textDecoration: "none",
    fontWeight: "bold",
  },
}));

interface SignInPageProps {}

interface BrandDetail {
  emailLogo?: string;
  primaryColor?: string;
}

export const SignInPage: React.FC<SignInPageProps> = () => {
  const classes = useStyles();
  const history = useHistory();
  const { networkId } = useParams<{ networkId?: string }>();
  const [brandDetail, setBrandDetail] = useState<BrandDetail | null>(null);
  const [loading, setLoading] = useState(true);

  const isMountedRef = useRef(false);
  useEffect(() => {
    isMountedRef.current = true;
    if (localStorage.getItem("brandId")) {
      localStorage.removeItem("brandId");
    }

    const fetchBrandDetail = async () => {
      if (networkId) {
        try {
          const detail = await AuthService.brandDetail(networkId);
          if (isMountedRef.current && detail?.emailLogo) {
            setBrandDetail(detail);
          }
        } catch (error) {
          console.error("Invalid networkId, fallback to default logo", error);
          // do nothing, fallback will apply
        }
      }
      setLoading(false);
    };

    fetchBrandDetail();
    
    return () => {
      isMountedRef.current = false;
    };
  }, []);


useEffect(() => {
  if (!networkId) return;

  const blockBack = () => {
    // Force the browser forward again
    window.history.go(1);
  };

  // Push a fake state so the first Back stays here
  window.history.pushState(null, "", window.location.href);

  // On any back attempt, immediately push the user forward
  window.addEventListener("popstate", blockBack);

  return () => {
    window.removeEventListener("popstate", blockBack);
  };
}, [networkId]);

  // TODO(branding): Replace this fallback asset once the final RB Pay logo is provided.
  const logoSrc = brandDetail?.emailLogo
    ? brandDetail.emailLogo
    : require("./RB_new_logo.png");
   if (loading) {
          return (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                  <CircularProgress />
              </div>
          );
      }

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{ minHeight: "100vh", width: "100%" }}
    >
      <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: "100%", display: "flex", justifyContent: "center" }}>

          {loading ? (
          // Show loader while branding is loading
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="300px" // keeps card size consistent
          >
            <CircularProgress />
          </Box>
        ) : (
          <div className={classes.cardWrapper}>
        <RBCardView>
          <img
            src={logoSrc}
            alt="logo"
            className={classes.logo}
          />
          <Typography className={classes.welcomeText}>
            Welcome to Relief Buddy
          </Typography>
          <Typography className={classes.subText}>
            Healthcare Staffing in Real-Time
          </Typography>
          <div className={classes.buttonContainer}>
            <RBButton
              className={classes.button}
              buttonBackgroundColor={brandDetail?.primaryColor ||Colors.themeDarkBlue}
              text="Login"
              variant="contained"
              type="submit"
              onClick={() => {
                 const state: { networkId?: string, brandDetail?:any } = {};

                if (networkId) {
                  state.networkId = networkId;
                  state.brandDetail=brandDetail;

                }
                history.push(RoutePathConstant.Login,state);

                 //history.push("/Login")
              }}
            />
            <Box mt={6} /> 
          </div>
          <div className={classes.registerContainer}>
            <Typography variant="body1">
            New to Relief Buddy?{" "}
              <Link
                className={classes.registerLink}
                style={{color:brandDetail?.primaryColor ||Colors.themeDarkBlue}}
                component="button"
                type="button"
                variant="body2"

                onClick={() => {
                   const state = {...(brandDetail && { brandDetail }) };
                  history.push({
                    pathname: networkId
                      ? `${RoutePathConstant.QuickRegistration}${networkId}`
                      : RoutePathConstant.QuickRegistration,
                    state,
                  });
                }}
              >
                Register Now
              </Link>
            </Typography>
          </div>
          
        </RBCardView>
         </div>
        )}
      </Grid>
    </Grid>
  );
};
